/**
 * Controller: TemplatesShowMembershipsModal
 */
angular.module('acme.view.application.templates.showMembershipsModal.controllers', [])
.controller('TemplatesShowMembershipsModalController', [ '$scope', '$uibModalInstance', 'MembershipsListData', function ($scope, $uibModalInstance, MembershipsListData) {

    $scope.errors = [];

    $scope.model = [];

    $scope.init = function() {
      if (MembershipsListData) {
        $scope.handlers.success.init(MembershipsListData);
      }else{
        $scope.handlers.error.init(MembershipsListData);
      }
    };

    $scope.hasData = function() {
      return ($scope.model instanceof Array && $scope.model.length > 0);
    };

    $scope.handlers = {
      success: {
        init: function(list) {
          $scope.model = list;
        }
      },
      error: {
        init: function (response) {
          $scope.errors = [
            {
              message: response.data.error
            }
          ];
        }
      }
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);